
var id = "favorite_border";
var markup = "<symbol viewBox=\"0 0 14.0 17.0\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"favorite_border\"><defs><clipPath id=\"favorite_border_i0\"><path d=\"M1680,0 L1680,1080 L0,1080 L0,0 L1680,0 Z\" /></clipPath><clipPath id=\"favorite_border_i1\"><path d=\"M14,15 L14,17 L0,17 L0,15 L14,15 Z M10,0 L10,6 L14,6 L7,13 L0,6 L4,6 L4,0 L10,0 Z\" /></clipPath></defs><g transform=\"translate(-1494.0 -244.0)\"><g clip-path=\"url(#favorite_border_i0)\"><g transform=\"translate(606.0 217.0)\"><g transform=\"translate(883.0 24.0)\"><g transform=\"translate(5.0 3.0)\"><g clip-path=\"url(#favorite_border_i1)\"><polygon points=\"0,0 14,0 14,17 0,17 0,0\" stroke=\"none\" /></g></g></g></g></g></g></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
